import { useEffect } from 'react';
import { emitTelemetry } from '@/lib/telemetry';

const INVOKED_SESSION_KEY = 'ent-60.search-invoked';

/**
 * Fires `global_search.invoked` once per browser session on the first palette open.
 * Uses sessionStorage so the event resets on tab close (per-session semantics).
 *
 * A60.16 — adoption telemetry for PRD §1.1 eval.
 */
export function useGlobalSearchInvokedTelemetry(
  isOpen: boolean,
  trigger: 'shortcut' | 'click',
): void {
  useEffect(() => {
    if (!isOpen) return;
    if (sessionStorage.getItem(INVOKED_SESSION_KEY)) return; // already fired this session

    sessionStorage.setItem(INVOKED_SESSION_KEY, '1');
    emitTelemetry('global_search.invoked', { trigger });
  }, [isOpen, trigger]);
}
